const ALGORITHM = "AES-GCM";
const KEY_SIZE = 256;
const RANDOMKEY_LENGTH = 16;
const IV_LENGTH = 12;
const ITERATIONS = 10;
const PBKDF2_HASH = "SHA-256";
const PASS_PHRASE = "@1454$$Keell&^#$%sOnlineWeb_**43";

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

const base64ToArrayBuffer = (base64) => {
  const binary_string = atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
};

const generateUniqueKey = async (randomVal) => {
  const dKey = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(PASS_PHRASE),
    { name: "PBKDF2" },
    false,
    ["deriveKey"]
  );

  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: randomVal,
      iterations: ITERATIONS,
      hash: PBKDF2_HASH,
    },
    dKey,
    { name: ALGORITHM, length: KEY_SIZE },
    true, // key is extractable
    ["encrypt", "decrypt"]
  );
};

export const encrypt = async (plaintext) => {
  if(plaintext == null || plaintext === undefined || plaintext.length == "")
    return plaintext;
  // Generate a random value for key derivation
  const randomVal = crypto.getRandomValues(new Uint8Array(RANDOMKEY_LENGTH));

  // Derive the encryption key
  const key = await generateUniqueKey(randomVal);

  // Generate a random Initialization Vector (IV)
  const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH));

  // Encode the plaintext
  const dataToEncrypt = new TextEncoder().encode(plaintext);

  // Encrypt the data using AES-GCM
  const encryptedBuffer = await crypto.subtle.encrypt(
    {
      name: ALGORITHM,
      iv: iv,
    },
    key,
    dataToEncrypt
  );

  // concatenated result as final output (IV + Randomval + CipherText)
  const totalBuffer = new Uint8Array(
    iv.byteLength + randomVal.byteLength + encryptedBuffer.byteLength
  );

  totalBuffer.set(iv, 0);
  totalBuffer.set(randomVal, iv.byteLength);
  totalBuffer.set(
    new Uint8Array(encryptedBuffer),
    iv.byteLength + randomVal.length
  );
  
  return arrayBufferToBase64(totalBuffer.buffer);
};

export const decrypt = async (ciphertextBase64) => {

    if(ciphertextBase64 == null || ciphertextBase64 === undefined || ciphertextBase64 == "")
    return ciphertextBase64;

  const fullBuffer = new Uint8Array(base64ToArrayBuffer(ciphertextBase64));

  // Check if the buffer is too short to contain IV, and randomval, CipherText
  if (fullBuffer.byteLength < IV_LENGTH + RANDOMKEY_LENGTH + 1) {
    throw new Error("Ciphertext too short or invalid format.");
  }
  const iv = fullBuffer.slice(0, IV_LENGTH);
  const randomVal = fullBuffer.slice(IV_LENGTH, IV_LENGTH + RANDOMKEY_LENGTH);
  const ciphertextBuffer = fullBuffer.slice(IV_LENGTH + RANDOMKEY_LENGTH);

  // Derive the key again using the extracted randomval
  const key = await generateUniqueKey(randomVal);

  // Decrypt the data using AES-GCM
  const decryptedBuffer = await crypto.subtle.decrypt(
    {
      name: ALGORITHM,
      iv: iv,
    },
    key,
    ciphertextBuffer
  );
  return new TextDecoder().decode(decryptedBuffer);
};
